define('views/components/sidebar/go_order_menus',['require','backbone','text!templates/components/sidebar/go_order_menus.html'],function (require) {
    var Backbone = require("backbone");
  
    var temp = require("text!templates/components/sidebar/go_order_menus.html");
  
    return Backbone.Marionette.ItemView.extend({
      template: _.template(temp)
      
    });
  });
  
